import React from 'react'
import CustomInput from 'Common/CustomInput/CustomInput'
import NumberConversion from './../../Utils/NumberConversion';
import { BiDollar } from 'react-icons/bi';
import AlertIcon from 'SVGS/AlertIcon';
import Show from 'Components/Show/Show';
import { GoAlert } from "react-icons/go";

const WriteOffServicelines = ({ serviceLines = [], serviceLinesError = [], handleBalanceChange, handleCheckboxChange, handleSelectAll }) => {
    const isAllSelected = serviceLines.length > 0 && serviceLines.every((line) => line.isChecked)
    const isIndeterminate = serviceLines.some((line) => line.isChecked) && !isAllSelected

    // Calculate if total adjusted amount exceeds remaining claim balance
    const checkedServiceLines = serviceLines.filter((line) => line.isChecked)
    const totalAdjustedAmount = checkedServiceLines.reduce((acc, line) => acc + (parseFloat(line.updatedAmount) || 0), 0)
    const totalClaimBalance = checkedServiceLines.reduce((acc, line) => acc + (parseFloat(line.chargeBalanceDue) || 0), 0)
    const shouldShowAlert = checkedServiceLines.length > 0 && totalAdjustedAmount > totalClaimBalance
    return (
        <div className="mt-4">
            <div className="overflow-x-auto border rounded border-slate-300">
                <table className="w-full border-collapse">
                    <thead>
                        <tr className="bg-slate-50">
                            <th className="w-12 px-3 py-2 text-sm font-semibold tracking-wide text-center capitalize border-b border-r text-slate-700 border-slate-300">
                                <input
                                    type="checkbox"
                                    checked={isAllSelected}
                                    ref={(input) => {
                                        if (input) input.indeterminate = isIndeterminate
                                    }}
                                    onChange={handleSelectAll}
                                    className="w-4 h-4 text-blue-600 rounded cursor-pointer border-slate-300 focus:ring-2 focus:ring-blue-500"
                                />
                            </th>
                            <th className="text-left py-2 px-3 font-semibold text-slate-700 min-w-[100px] text-sm capitalize tracking-wide border-r border-b border-slate-300">
                                Proc Code
                            </th>
                            <th className="text-left py-2 px-3 font-semibold text-slate-700 min-w-[100px] text-sm capitalize tracking-wide border-r border-b border-slate-300">
                                Billed
                            </th>
                            <th className="text-left py-2 px-3 font-semibold text-slate-700 min-w-[100px] text-sm capitalize tracking-wide border-r border-b border-slate-300">
                                Balance
                            </th>

                            <th className="px-3 py-2 text-sm font-semibold tracking-wide text-left capitalize border-b border-r text-slate-700 border-slate-300">
                                Amount
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {serviceLines.length > 0 ? (
                            serviceLines.map((line, index) => {
                                const isSelected = line.isChecked || false

                                return (
                                    <tr
                                        key={line.visitChargeId}
                                        className={`hover:bg-blue-50 ${isSelected ? 'bg-blue-50' : ''}`}
                                    >
                                        <td className="px-3 py-2 text-center border-b border-r border-slate-300">
                                            <input
                                                type="checkbox"
                                                checked={isSelected}
                                                disabled={!line.chargeBalanceDue || line.chargeBalanceDue === 0}
                                                onChange={(e) => handleCheckboxChange(line.visitChargeId, e.target.checked)}
                                                className="w-4 h-4 text-blue-600 rounded cursor-pointer border-slate-300 focus:ring-2 focus:ring-blue-500"
                                            />
                                        </td>
                                        <td className="px-3 py-2 text-sm text-left border-b border-r border-slate-300">
                                            {line.procCode || '-'}
                                        </td>
                                        <td className="px-3 py-2 text-sm text-left border-b border-r border-slate-300">
                                            {NumberConversion(line.totalAmount) || '-'}
                                        </td>
                                        <td className="px-3 py-2 text-sm text-left border-b border-r border-slate-300">
                                            {NumberConversion(line.chargeBalanceDue) || '-'}
                                        </td>

                                        <td className="px-3 py-2 text-sm border-b border-r border-slate-300">
                                            <div className="justify-end ">
                                                <CustomInput
                                                    prefixIcon={<BiDollar size={13} className="text-gray-600" />}
                                                    name={`balance_${line.visitChargeId}`}
                                                    value={line.updatedAmount}
                                                    onChange={(e) => handleBalanceChange(line.visitChargeId, e.target.value)}
                                                    isNumeric
                                                    isFloat
                                                    maxFloat={2}
                                                    wrapperClass="w-full max-w-[90px]"
                                                    className="text-right"
                                                    disabled={!isSelected || !line.chargeBalanceDue || line.chargeBalanceDue === 0}
                                                />
                                                {serviceLinesError[index].updatedAmountError}
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })
                        ) : (
                            <tr>
                                <td colSpan={5} className="px-3 py-8 text-sm text-center border-b text-slate-500 border-slate-300">
                                    No service lines available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <Show when={shouldShowAlert}>
                <div className="flex items-start gap-2 p-3 mt-4 border rounded-lg border-amber-300 bg-amber-50">
                    <GoAlert size={18} color="#d97706" className="mt-0.5 flex-shrink-0" />
                    <span className="mt-1 text-sm font-medium leading-tight text-amber-800">
                        The total adjusted amount should not exceed the remaining claim balance
                    </span>
                </div>
            </Show>

        </div>
    )
}

export default WriteOffServicelines